import { useAppSelector } from "app/hooks";

const ClinicName = ({ id }: { id: number | null | undefined }) => {
  const clinicName = useAppSelector((state) => state.clinics[id || 0]?.name);

  if (!id) return null;

  return <>{clinicName}</>;
};

export default ClinicName;
